export function useSelectOnFocus(): (e: Event) => void {
  return (e: Event) => {
    if (!(e.target instanceof HTMLInputElement)) {
      return;
    }
    e.target.select();
  };
}
